import type {CanvasChatMessage} from './canvas-types';
const VERIFIED_FOR_MS=15_000;
/** A successful poll verifies this message, not another task's typing session. */
export function recordConceptPoll(message:CanvasChatMessage,setStatus:string|undefined,now=Date.now()):CanvasChatMessage{
 return {...message,conceptRunVerifiedAt:message.conceptsRun?.status==='generating' && (setStatus===undefined || setStatus==='generating') ? now : undefined};
}
export function isCanvasMessageLive(message:CanvasChatMessage,localWorking:boolean,now=Date.now()):boolean{
 if(message.conceptsRun?.autoBuild && localWorking && message.isStreaming && message.agentTaskGroups?.some(group=>group.status==='active' && group.steps.some(step=>step.toolName==='run_angles_to_campaign')))return true;
 if(message.conceptsRun && message.conceptsRun.status!=='generating' && !(message.playbookProgress && !message.playbookProgress.isDone))return false;
 if(localWorking && message.isStreaming)return true;
 const verified=message.conceptRunVerifiedAt;
 return message.conceptsRun?.status==='generating' && typeof verified==='number' && now>=verified && now-verified<VERIFIED_FOR_MS;
}
